import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";
import Modal from "@components/ModalTemplate";
import SectionHeader from "@components/SectionHeader";
import Button from "@components/Button";
import "./style.scss";

const DEFAULTS = {
  title: "Danke für dein Feedback!",
  body: "Schau vorbei, was du mit deinen verdienten Punkten bereits einlösen kannst.",
  buttonLabel: "Jetzt entdecken",
};

export default NiceModal.create((props = {}) => {
  const modal = useModal();
  const navigate = useNavigate();

  const title = props.title ?? modal.args?.title ?? DEFAULTS.title;
  const body = props.body ?? modal.args?.body ?? DEFAULTS.body;
  const buttonLabel =
    props.buttonLabel ?? modal.args?.buttonLabel ?? DEFAULTS.buttonLabel;
  const href = props.href ?? modal.args?.href;
  const onAction = props.onAction ?? modal.args?.onAction;

  function handleClose() {
    modal.hide();
  }

  function handleAction() {
    modal.hide();
    if (typeof onAction === "function") {
      onAction();
      return;
    }
    if (href) {
      navigate(href);
    }
  }

  return (
    <Modal
      isOpen={modal.visible}
      onClose={handleClose}
      onAfterClose={() => modal.remove()}
      innerClass="ultrainsider qr-award-info-modal"
    >
      <div className="qr-award-info-modal__content">
        <div className="qr-award-info-modal__copy">
          <SectionHeader>{title}</SectionHeader>
          {body && <p className="qr-award-info-modal__body">{body}</p>}
        </div>
        <Button action={handleAction} btnClass="ultra-insider">
          {buttonLabel}
        </Button>
      </div>
    </Modal>
  );
});
